var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 5.70027C3.6 4.42723 4.10571 3.20633 5.00589 2.30616C5.90606 1.40598 7.12696 0.900269 8.4 0.900269C9.67304 0.900269 10.8939 1.40598 11.7941 2.30616C12.6943 3.20633 13.2 4.42723 13.2 5.70027C13.2 6.97331 12.6943 8.19421 11.7941 9.09438C10.8939 9.99456 9.67304 10.5003 8.4 10.5003C7.12696 10.5003 5.90606 9.99456 5.00589 9.09438C4.10571 8.19421 3.6 6.97331 3.6 5.70027ZM0 18.9865C0 15.2928 2.9925 12.3003 6.68625 12.3003H10.1138C13.8075 12.3003 16.8 15.2928 16.8 18.9865C16.8 19.6015 16.3013 20.1003 15.6862 20.1003H1.11375C0.49875 20.1003 0 19.6015 0 18.9865ZM18.9 12.6003V10.2003H16.5C16.0013 10.2003 15.6 9.79902 15.6 9.30027C15.6 8.80152 16.0013 8.40027 16.5 8.40027H18.9V6.00027C18.9 5.50152 19.3013 5.10027 19.8 5.10027C20.2987 5.10027 20.7 5.50152 20.7 6.00027V8.40027H23.1C23.5988 8.40027 24 8.80152 24 9.30027C24 9.79902 23.5988 10.2003 23.1 10.2003H20.7V12.6003C20.7 13.099 20.2987 13.5003 19.8 13.5003C19.3013 13.5003 18.9 13.099 18.9 12.6003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/userPlus.c99b804a7d2406bb525db67d51e430ff.svg";
export { ForwardRef as ReactComponent };